/** @format */

import React, { useState } from "react";
import { apiUsers } from "../api";
import { getAlert } from "../util/alert";
import Constantes from "../util/Constantes";

/* Begin By Javi */
import alertify from "alertifyjs";
import { Loader } from "../util/loader";
/* End By Javi */

export const Recuperarcontraseña = () => {
  /* Begin By Javi */
  const [Loading, setloading] = useState(false);
  const [alertMessage, setMessage] = useState("Recuperar Contraseña");
  /* End By Javi */
  const [dni, setDni] = useState("");
  const [confirmarEmailEnvio, setConfirmarEmailEnvio] = useState({
    ejecucion: false,
    estado: false,
  });
  const objValidaciones = {
    usuarioNoExiste: false,
    correoInvalidoUsuario: false,
    showForm: false,
  };
  const [validaciones, setvalidaciones] = useState(objValidaciones);
  const [emailInformation, setEmailInformation] = useState({});

  const handleClickRecuperarUsuario = async () => {
    /* Begin By Javi */
    setloading(true);
    /* End By Javi */
    const Payload = {
      apoderado_id: emailInformation.apoderado_id,
      usuario: emailInformation.usuario,
      apaterno: emailInformation.apaterno,
      amaterno: emailInformation.amaterno,
      nombres: emailInformation.nombres,
      email: emailInformation.email,
      dni: dni,
    };
    const promise = apiUsers.sendMailCredencial(Payload, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        getAlert(
          Constantes().SendMail,
          process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
        );
        setConfirmarEmailEnvio({ ejecucion: true, estado: true });
      }
    });
  };

  const handleConsultarEmail = async () => {
    /* Begin By Javi */
    setloading(true);
    if (dni == "") {
      setloading(false);
      alertify.alert("Favor ingrese DNI !").setHeader(alertMessage);
      return;
    }
    /* End By Javi */
    const promise = apiUsers.GetEmail(dni, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        if (res.email != "") {
          setEmailInformation(res);
          setvalidaciones({
            usuarioNoExiste: false,
            correoInvalidoUsuario: false,
            showForm: true,
          });
          return;
        } else {
          setEmailInformation(res);
          setvalidaciones({
            usuarioNoExiste: false,
            correoInvalidoUsuario: true,
            showForm: true,
          });
        }
      } else {
        setEmailInformation({});
        setvalidaciones({
          usuarioNoExiste: true,
          correoInvalidoUsuario: false,
          showForm: false,
        });
      }
    });
  };

  const handleInputChange = (e) => {
    const esValido = e.target.validity.valid;
    if (esValido) {
      setDni(e.target.value);
    }
  };
  return (
    <section className="row" style={{ color: "#ffffff" }}>
      {Loader(Loading)}
      <div id="branding" className="imgBx"></div>
      <div className="contentBx">
        <div className="formBx">
          <img src={Constantes().Imagen.LogoWeb} className="logoBx mb-2"></img>
          <h4 className="mb-5">Recuperé su contraseña </h4>
          {!validaciones.showForm ? (
            <form>
              <div className="inputBx">
                <input
                  type="text"
                  className="form-control"
                  placeholder="DNI"
                  maxLength="9"
                  name="dni"
                  pattern="[0-9]{0,13}"
                  value={dni}
                  onChange={handleInputChange}
                />
                {/* {validaciones.usuarioNoExiste ? (
                    <label>Usuario No existe </label>
                  ) : null} */}
              </div>
              <div className="inputBx col-12">
                <input
                  type="button"
                  className="btnSubmit"
                  value="Buscar"
                  onClick={handleConsultarEmail}
                />
              </div>
            </form>
          ) : !validaciones.correoInvalidoUsuario && validaciones.showForm ? (
            <div className="form-olvido">
              <div>
                <label className=" mb-4">
                  Enviaremos un correo de verificación al siguiente correo
                  electrónico:
                </label>
                <label>
                  Correo : {emailInformation.email.substr(0, 3)} *************{" "}
                  {emailInformation.email.substr(
                    emailInformation.email.length - 6,
                    emailInformation.email.length
                  )}
                </label>
                <div className="inputBx mt-5 form-group d-flex justify-content-end">
                  <input
                    type="button"
                    className="btnSubmit"
                    value="Enviar"
                    onClick={handleClickRecuperarUsuario}
                  />
                </div>
              </div>
              {confirmarEmailEnvio.ejecucion ? (
                <div>
                  {confirmarEmailEnvio.estado ? (
                    <div>
                      <label className=" mb-4">
                        Correo de recuperación de contraseña ha sido enviado con
                        éxito.
                      </label>
                      <label className=" mb-4">Por favor revisar </label>
                      <br />
                      <label>
                        correo : {emailInformation.email.substr(0, 3)}{" "}
                        *************{" "}
                        {emailInformation.email.substr(
                          emailInformation.email.length - 6,
                          emailInformation.email.length
                        )}
                      </label>
                    </div>
                  ) : (
                    <div>
                      <label>¡Error al recuperar su contraseña!</label>
                      <label>
                        Para acceder al sistema, por favor envié un correo al
                      </label>
                      <label>claveapoderados@upn.edu.pe</label>
                    </div>
                  )}
                </div>
              ) : null}
            </div>
          ) : (
            <div>
              <label>
                No cuenta con un correo registrado para acceder al sistema, por
                favor envié un correo al
              </label>
              <label>claveapoderados@upn.edu.pe</label>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
